<div class="details-item" [class.offset-sm]="isSmallOffset" [class.offset-no]="noOffset" [class.full-width]="fullWidth">
  <div
    class="details-item-label align-center"
    [ngClass]="'details-item-label--' + labelStyle"
    [class.details-item-label-nowrap]="noWrapLabel"
  >
    {{ label }}
  </div>

  <app-text-with-placeholder
    class="details-item-value"
    [width]="placeholderWidth"
    [height]="height"
    [showPlaceholder]="showPlaceholder"
    [class.not-available]="!value"
    [class.no-break]="noBreak"
    [class.loading]="showPlaceholder"
    [placeholderRows]="placeholderRows"
    [style.minHeight.rem]="minHeight"
    [ngClass]="valueClass"
    [title]="value | notAvailable"
  >
    {{ templateValueOnly ? '' : (value | notAvailable) }}<ng-content></ng-content>
  </app-text-with-placeholder>
</div>
